import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Slider from 'react-slick'

function Partner({classes=""}) {
    let settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1,
        speed: 10000,
        cssEase: 'linear',
        arrows :false,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
          ],
      }; 
  return (
    <>
      <style>{`
        .partner_img img { position: relative; width: auto !important; height: 55px; margin: 0 auto; filter: grayscale(0); max-width: 80%; object-fit: contain; transition: all .3s ease-in; }
        .slick-slide + .slick-slide  .partner_img { border-left: 1px solid #cccccc73; }
        .partner-container { padding: 55px 0; }
        .partner_img:hover img { filter: grayscale(1); transform: translateY(-4px); }
        .partner_img { padding: 6px 0; }
        @media (max-width:767.98px) {
          .partner_img img { height: 40px; }
        }
      `}</style>
        <div className={`partner-container  ${classes}`}>
            <Container>
                <Row className='align-items-center'>
                    <Col lg={12}>
                        <div className="partner_slider">
                            <Slider {...settings}>
                                <div className='partner_img'>
                                   <img src="../assets/images/partner/1.png" alt="" />
                                </div>
                                <div className='partner_img'>
                                   <img src="../assets/images/partner/2.png" alt="" />
                                </div>
                                <div className='partner_img'>
                                   <img src="../assets/images/partner/3.png" alt="" />
                                </div>
                                <div className='partner_img'>
                                   <img src="../assets/images/partner/4.png" alt="" />
                                </div>
                                <div className='partner_img'>
                                   <img src="../assets/images/partner/5.png" alt="" />
                                </div>
                                <div className='partner_img'>
                                   <img src="../assets/images/partner/6.png" alt="" />
                                </div>
                                <div className='partner_img'>
                                   <img src="../assets/images/partner/7.png" alt="" />
                                </div>
                                <div className='partner_img'>
                                   <img src="../assets/images/partner/8.jpg" alt="" />
                                </div>
                            </Slider>
                        </div>
                    </Col>
                </Row>

            </Container>
        </div>
    </>
  )
}

export default Partner